import { sanitizeProfile, type PlayerProfile } from './model';
import type { ProgressRepository } from './repository';

/** Used when localStorage is missing, blocked, or throws. Progress lasts for the tab session. */
export class MemoryProgressRepository implements ProgressRepository {
  readonly kind = 'memory' as const;
  private profile: PlayerProfile = sanitizeProfile(null);

  async load(): Promise<PlayerProfile> {
    return sanitizeProfile(this.profile);
  }

  async save(profile: PlayerProfile): Promise<void> {
    this.profile = sanitizeProfile(JSON.parse(JSON.stringify(profile)));
  }

  async reset(): Promise<void> {
    this.profile = sanitizeProfile(null);
  }
}
